var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-recaptcha',{ref:"recaptcha",attrs:{"sitekey":_vm.sitekey},on:{"verify":_vm.onVerify,"expired":_vm.onExpired,"reset":_vm.onReset}})
}
var staticRenderFns = []

export { render, staticRenderFns }